import { render, staticRenderFns } from "./NewTransferFeedback.vue?vue&type=template&id=aecb4ce8&scoped=true"
import script from "./NewTransferFeedback.vue?vue&type=script&lang=ts"
export * from "./NewTransferFeedback.vue?vue&type=script&lang=ts"
import style0 from "./NewTransferFeedback.vue?vue&type=style&index=0&id=aecb4ce8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecb4ce8",
  null
  
)

export default component.exports